import { setAccountStoreInitialized } from '../actions/internalActions';
import { mutator } from 'satcheljs';
import getStore from '../store/store';

mutator(setAccountStoreInitialized, ({ initialized }) => {
    getStore().isAccountsStoreInitialized = initialized;
});
